/**
 * @generated SignedSource<<80c3e4c3c39c78fad9dff32935c8ec0c>>
 * @relayHash 1f96316e590a2b194e51c68e90ba41fe
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 241b0a4ae1b4aa71513dc33dc53ca7f3c35e7c5a3662ea814901abd521642ef3

import type { ConcreteRequest } from 'relay-runtime';
export type ConfluenceEdition = "FREE" | "PREMIUM" | "STANDARD" | "%future added value";
export type waitForEditionChangeQuery$variables = Record<PropertyKey, never>;
export type waitForEditionChangeQuery$data = {
  readonly tenant: {
    readonly editions: {
      readonly confluence: ConfluenceEdition;
    };
  } | null | undefined;
};
export type waitForEditionChangeQuery = {
  response: waitForEditionChangeQuery$data;
  variables: waitForEditionChangeQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": "tenant",
    "concreteType": "ConfluenceTenantContext",
    "kind": "LinkedField",
    "name": "confluence_tenantContext",
    "plural": false,
    "selections": [
      {
        "concreteType": "Editions",
        "kind": "LinkedField",
        "name": "editions",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "confluence"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "name": "waitForEditionChangeQuery",
    "selections": (v0/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "waitForEditionChangeQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "1f96316e590a2b194e51c68e90ba41fe",
    "id": "241b0a4ae1b4aa71513dc33dc53ca7f3c35e7c5a3662ea814901abd521642ef3",
    "metadata": {},
    "name": "waitForEditionChangeQuery",
    "operationKind": "query",
    "text": "query waitForEditionChangeQuery{tenant:confluence_tenantContext{editions{confluence}}}"
  }
};
})();

(node as any).hash = "6fd7b1d4e0dd25a6c39ba6c8851caa63";

export default node;
